import React from 'react';
import '../static/styles/form-text.scss';

interface Props {
	leftText: string,
	rightText: string,
	height?: string,
	leftSize?: string,
	rightSize?: string
	leftColor?: string,
	rightColor?: string,
	leftBold?: boolean,
	rightBold?: boolean,
	leftWidth?: string,
	rightWidth?: string
}

interface State {
}

class InsFormText extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
	}

	render() {
		return (
			<div className="form-text-content"
			     style={{height: this.props.height ? this.props.height : "0.6rem"}}>
				<div className="text-left" style={{width: this.props.leftWidth ? this.props.leftWidth : "30%"}}>
					<div style={{
						fontSize: this.props.leftSize ? this.props.leftSize : "0.28rem"
						, color: this.props.leftColor ? this.props.leftColor : "#9C9898"
						, fontWeight: this.props.leftBold ? "bold" : "normal"
					}}>
						{this.props.leftText}
					</div>
				</div>
				<div className="text-right" style={{width: this.props.rightWidth ? this.props.rightWidth : "70%"}}>
					<div style={{
						fontSize: this.props.rightSize ? this.props.rightSize : "0.28rem"
						, color: this.props.rightColor ? this.props.rightColor : "#333"
						, fontWeight: this.props.rightBold ? "bold" : "normal"
					}}>
						{this.props.rightText}
					</div>
				</div>
			</div>
		)
	}
}

export default InsFormText;
